import { SystemFuncArgs } from '$legacyecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import FocusedViewport from 'editor/components/FocusedViewport';
import { getSheetToScreenTransform } from 'editor/utils/transform';
import { Components } from '../components';
import Markup from '../components/Markup';
import MarkupKit from '../components/MarkupKit';
import Overlay from '../components/Overlay';

export const focusedMarkupComponents = [
  CarnivoreDoc,
  MarkupKit,
  FocusedViewport,
  Overlay,
  Markup,
];

export function focusViewport(args: SystemFuncArgs<Components>): void {
  const { entity, components, world } = args;
  const { doc } = components.get(CarnivoreDoc);
  const { MKMarkup } = components.get(MarkupKit);
  const markupComp = components.get(Markup);
  const { sheetHeight } = components.get(FocusedViewport);

  if (!markupComp.mkMarkup) {
    markupComp.mkMarkup = new MKMarkup(markupComp.markup.jsonBlob);
  }

  let { left, bottom, right, top } = markupComp.mkMarkup.getBBox();

  let padding = 200;

  const [scale] = getSheetToScreenTransform(world);

  if (scale) {
    left *= scale;
    bottom *= scale;
    right *= scale;
    top *= scale;
    padding *= scale;
  }

  doc.fitToBox(
    left - padding,
    sheetHeight - bottom + padding,
    right + padding,
    sheetHeight - top - padding
  );

  entity.destroy();
}
